// extracted by mini-css-extract-plugin
module.exports = {"home":"CampoHome_home__EKLdf"};